"use client"

import { memo } from "react"
import { useTranslation } from "@/components/language-provider"
import { cn } from "@/lib/utils"
import type { Locale } from "@/types"

const LanguageToggle = memo(function LanguageToggle() {
  const { locale, setLocale } = useTranslation()

  return (
    <div className="flex items-center gap-0.5 rounded-full border border-gray-200 bg-gray-50 p-0.5" data-testid="beauty-academy-language-toggle">
      {(["tr", "en"] as Locale[]).map((lang) => (
        <button
          key={lang}
          onClick={() => setLocale(lang)}
          data-testid={`beauty-academy-language-toggle-option-${lang}`}
          className={cn(
            "rounded-full px-2.5 py-1 text-xs font-semibold transition-colors",
            locale === lang
              ? "bg-gray-900 text-white"
              : "text-gray-500 hover:text-gray-900"
          )}
        >
          {lang.toUpperCase()}
        </button>
      ))}
    </div>
  )
})

export default LanguageToggle
